import { createAction, props } from '@ngrx/store';
import { ITermData } from 'src/app/shared/types/term';

const termIsCreated = 'TERM_IS_CREATED';
const removeRecentTerm = 'REMOVE_RECENT_Term';
export const termIsCreatedAction = createAction(
  termIsCreated,
  props<{ newTerm: ITermData }>()
);

export const removeRecentTermAction = createAction(removeRecentTerm);
